import React from 'react';

export const NotificationsHeader: React.FC = () => {
  return (
    <div className='bg-white px-10 py-6'>
      <h2 className='font-semibold text-cxcentral-green mb-1'>Notifications</h2>
      <p className='text-[#667085] text-sm'>Configure notifications for Pronetx products and services</p>
    </div>
  );
};
